export default __webpack_public_path__ + "static/media/founders_loft.e1bc123e.png";